import React from "react";
import { Route, Switch } from "react-router-dom";

import Todo from "./Todo";
import ReminderPage from "./ReminderPage";
import BigCalender from "./BigCalendar";
import Contacts from "./Contacts";

function Efficiency(props: any) {
  let routeMatch = props.match;

  return (
    <div className="gx-main-content-wrapper">
      <Switch>
        <Route path={`${routeMatch.url}/reminders`} component={ReminderPage} />
        <Route path={`${routeMatch.url}/todo`} component={Todo} />
        <Route path={`${routeMatch.url}/calendar`} component={BigCalender} />
        <Route path={`${routeMatch.url}/contacts`} component={Contacts} />
      </Switch>
    </div>
  );
}

export default Efficiency;
